/**
 * Environment utilities for the UI package.
 *
 * NOTE: isDesktopAppMode and isMobileAppMode are internal to @moment/ui only.
 * Outside of this package, use `env.isDesktopApp` and `env.isMobileApp` from @moment/state instead.
 */

export const isDesktopAppMode = () => {
	return process.env["MODE"] === "desktop";
};

export const isMobileAppMode = () => {
	return process.env["MODE"] === "mobile";
};

export const isServiceWorkerDisabled = () => {
	return process.env["DISABLE_SERVICE_WORKER"] === "true";
};
